import { get } from 'lodash';
import { DEFAULT_ERROR, FEATURE_FLAGS } from 'utils/constants';
import DatadogHandler from 'utils/datadog';
import {
  msCancelAdvancePaymentReceipt,
  msCreateAdvancePaymentReceiptForRegistration,
  msFetchAdvancePaymentReceiptsForRegistration,
  msFetchAllCreditDebitNotes,
  msFetchAllPaymentTypes,
  msFindAllInvoiceForAllCenter,
  msGetAdvancePaymentItemAmountForRegistration,
  msGetECDAAdvancePaymentItemAmountForRegistration,
  msGetAllBankBicCodes,
  msGetCdaAccountStatementUploadURL,
  msGetChildBalanceSheet,
  msGetGiroFormUploadURL,
  msGetRegistrationChildBalanceSheet,
  msGetRegistrationRefundChildBalance,
  msGetSiblingBirthCertificateUploadURL,
  msSaveRegGiroApplication,
  msSaveGiroApplication,
  msSkipGiroForRegistration,
  msTransferRegistrationChildBalance,
  msSkipRegistrationPaymentStep,
  msCreateECDAAdvancePaymentReceiptForRegistration,
  msSkipEcdaRegistrationPaymentStep,
  msUpdateChildTradeDebtNotificationConfig,
  msGetCurrentChildRefundStatus,
  msGetTradeDebtNotifications,
  msFetchAdvancePaymentReceiptsForEcdaRegistration,
  msCreateOfflineReceipt,
  msWriteOffCreditBalance,
  msWriteOffInvoices,
  msCancelReceipt,
  msUnlinkReceipt,
  msUpdateRefundStatus,
  msFetchAdvancePaymentReceipts,
  msAdjustInvoiceAmountByInvoiceItemsPreview,
  msAdjustInvoiceAmountByInvoiceItems,
  msCreateAdvancePaymentReceipt,
  msGetAllRefundChildBalanceForECDA,
  msGetAllRefundChildBalance,
  msFetchAllRefundsList,
  msCreateAdhocChildRefund,
  msCreateAdHocCreditNote,
  msMarkChildToGenerateGiroRefund,
  msUnmarkChildToGenerateGiroRefund,
  msFetchAllPurchaseItems,
  msSearchInvoice,
  msSearchFinance,
  msValidateProgramBillingRequest,
  msGetAllProgramBillings,
  msGetAllCustomSubsidyType,
  msGetAllActiveSubsidies,
  msGetProgramBillingUploadURL,
  msGetFinanceDocumentUploadURL,
  msCreateProgramBillingRequest,
  msGetChildSOAByYear,
  msGetHistoryBillingAdjustments,
  msExportProgramBillingUploadTemplate,
  msCancelBulkInvoiceRequest,
  msFetchAllUploadedSubsidyFiles,
  msExportProgramBillingMasterFile,
  msGetAllConsolidatedRefund,
  msGetTaxRateAndAmount,
  msVoidCustomSubsidy,
  msRemoveCustomSubsidy,
  msExemptCustomSubsidy,
  msCancelCustomSubsidy,
  msCreateCustomSubsidy,
  msUploadSubsidyFile,
  msRejectCustomSubsidy,
  msEditHistorySubsidy,
  msGetChildFinancialAssistanceStatus,
  msGiroSiblingSelectionAction,
  msGetSiblingBirthCertificateTempUploadURL,
  msTransferChildBalance,
  msApproveCustomSubsidy,
  msGetSubsidyDebitNoteAmount,
  msGenerateGiroDeduction,
  msGenerateGiroRefund,
  msCancelExportGiroRefund,
  msGetDebtWriteOffDocUploadUrls,
  msGetCreditWriteOffSupportingDocumentUploadURL,
  msFindAllValidDownloadedGiroFiles,
  msGetHHIHistory,
  msGetFinanceDocumentPdfPresignedURL,
} from 'services/FinanceService';
import {
  msExportGiroPdf,
  msSaveUploadedRegDocument,
  msGetEcdaCdaAccountStatementUploadURL,
  msGetEcdaSiblingBirthCertificateUploadURL,
} from 'services/RegistrationsService';
import {
  msUpdateBankAccountBillRefNumber,
  msGetBankAccountStatusChangeReasonsByStatus,
  msUpdateBankAccountStatus,
} from 'services/BankAccountService';
import {
  FETCH_ALL_PURCHASE_ITEMS,
  FETCH_ALL_INVOICE_BY_FKCHILD,
  FETCH_CHILD_BALANCE,
  FETCH_CHILD_BALANCE_SHEET,
  FETCH_CHILD_BANK_ACCOUNTS,
  FETCH_ALL_BANKS,
  FETCH_ALL_INVOICES_FOR_ALL_CENTRES,
  FETCH_FINANCE,
  FETCH_ALL_REFUND,
  FETCH_ALL_UPLOADED_SUBSIDY_FILES,
  FETCH_ALL_DOWNLOADED_GIRO_FILES,
  FETCH_PAYMENT_TYPES,
  BANK_ACC_STATUS_CHANGE_REASON_BY_STATUS,
  EMPTY_REASONS_GIRO,
  FETCH_ADVANCE_PAYMENT_RECEIPTS,
  ALL_CUSTOM_SUBSIDY_TYPE,
  ACTIVE_SUBSIDIES,
  SUBSIDY_DEBIT_AMOUNT,
  ALL_ABSENT_CHILD_VOID_SUBSIDY,
  FETCH_SEARCH_INVOICE,
  FETCH_CHILD_REFUNDS,
  FETCH_ENROLLED_CENTRES,
  FETCH_ADVANCE_PAYMENT_ITEM_AMOUNT,
  FETCH_ADVANCE_PAYMENT_RECEIPTS_FOR_REGISTRATION,
  FETCH_CHILD_FINANCIAL_ASSISTANCE_STATUS,
  FETCH_STATEMENT_OF_ACCOUNT_LOADING,
  FETCH_STATEMENT_OF_ACCOUNT_SUCCESS,
  FETCH_STATEMENT_OF_ACCOUNT_ERROR,
  FETCH_HISTORY_SUBSIDIES_LOADING,
  FETCH_HISTORY_SUBSIDIES_SUCCESS,
  FETCH_HISTORY_SUBSIDIES_ERROR,
  FETCH_ALL_BULK_INVOICES_LOADING,
  FETCH_ALL_BULK_INVOICES_SUCCESS,
  FETCH_ALL_BULK_INVOICES_ERROR,
  FETCH_DEBT_WRITE_OFF_LOADING,
  FETCH_DEBT_WRITE_OFF_SUCCESS,
  FETCH_DEBT_WRITE_OFF_ERROR,
  FETCH_ALL_PGM_BILLING_LOADING,
  FETCH_ALL_PGM_BILLING_SUCCESS,
  FETCH_ALL_PGM_BILLING_ERROR,
  FETCH_CREDIT_DEBIT_NOTE_LOADING,
  FETCH_CREDIT_DEBIT_NOTE_SUCCESS,
  FETCH_CREDIT_DEBIT_NOTE_ERROR,
  FETCH_ALL_REG_CHILD_BALANCE_LOADING,
  FETCH_ALL_REG_CHILD_BALANCE_SUCCESS,
  FETCH_ALL_REG_CHILD_BALANCE_ERROR,
  FETCH_ALL_REG_CHILD_REFUNDS_LOADING,
  FETCH_ALL_REG_CHILD_REFUNDS_SUCCESS,
  FETCH_ALL_REG_CHILD_REFUNDS_ERROR,
  FETCH_ALL_REG_CHILD_TOTAL_ADVANCE_PAYMENTS_LOADING,
  FETCH_ALL_REG_CHILD_TOTAL_ADVANCE_PAYMENTS_SUCCESS,
  FETCH_ALL_REG_CHILD_TOTAL_ADVANCE_PAYMENTS_ERROR,
  FETCH_ADJUST_INVOICE_AMT_LOADING,
  FETCH_ADJUST_INVOICE_AMT_SUCCESS,
  FETCH_ADJUST_INVOICE_AMT_ERROR,
  FETCH_ALL_INVOICES_BY_CHILD,
  FETCH_SUBSIDIES_LOADING,
  FETCH_SUBSIDIES_SUCCESS,
  FETCH_SUBSIDIES_ERROR,
  FETCH_TRADE_DEBT_NOTIFICATION_LOADING,
  FETCH_TRADE_DEBT_NOTIFICATION_SUCCESS,
  FETCH_TRADE_DEBT_NOTIFICATION_ERROR,
  FETCH_TAX_RATE_AND_AMOUNT,
  CLEAR_TAX_RATE_AND_AMOUNT,
  FETCH_CHILD_SOA_BY_YEAR_LOADING,
  FETCH_CHILD_SOA_BY_YEAR_SUCCESS,
  FETCH_CHILD_SOA_BY_YEAR_ERROR,
  FETCH_CHILD_REFUND_STATUS_LOADING,
  FETCH_CHILD_REFUND_STATUS_SUCCESS,
  FETCH_CHILD_REFUND_STATUS_ERROR,
  ALL_CONSOLIDATED_REFUNDS,
  FETCH_ALL_CHILD_REFUNDS_LOADING,
  FETCH_ALL_CHILD_REFUNDS_SUCCESS,
  FETCH_ALL_CHILD_REFUNDS_ERROR,
  FETCH_ALL_VALID_DOWNLOADED_GIRO_FILES,
  FETCH_ADVANCE_PAYMENT_RECEIPTS_FOR_ECDA_REGISTRATION,
  FETCH_ECDA_ADVANCE_PAYMENT_ITEM_AMOUNT,
  HHI_HISTORY_LOADING,
  HHI_HISTORY_SUCCESS,
  HHI_HISTORY_ERROR,
} from './actionTypes';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { actionHandlerWithFeatureFlag, parseGraphQLError } from '../../utils';
import {
  FIND_ALL_UPLOADED_SUBSIDY_FILES,
  FIND_ALL_PURCHASE_ITEM,
  GET_CHILD_CURRENT_BALANCE,
  INVOICES_BY_FK_CHILD,
  BANK_ACCOUNTS_INFO_BY_CHILD_ID,
  FIND_ALL_BANK_BIC_CODE,
  SEARCH_FINANCE,
  FIND_ALL_INVOICE,
  FIND_ALL_CONSOLIDATED_REFUND,
  UPLOAD_SUBISDY_FILE,
  UPLOAD_GIRO_FILE,
  FIND_ALL_DOWNLOADED_GIRO_FILES,
  GENERATE_GIRO_REFUND_ARCHIVE,
  GENERATE_GIRO_DEDUCTION_ARCHIVE,
  EXPORT_GIRO_APPLICATION_PDF,
  CREATE_OFFLINE_INVOICE,
  CREATE_RECEIPT_FOR_OFFLINE_PAYMENT,
  GET_ID_DOCUMENT_TYPE_CONFIG_UPLOAD_URL,
  GET_ID_DOCUMENT_TYPE_CONFIG_GIRO_URL,
  GET_FINANCE_DOCUMENT_UPLOAD_URL,
  CREATE_ADHOC_CREDIT_NOTE,
  SAVE_DOCUMENT,
  PAYMENT_TYPES,
  GET_BANK_ACC_STATUS_CHANGE_REASON_BY_STATUS,
  UPDATE_GIRO_STATUS_WITH_REASON_MODEL,
  GET_ALL_CUSTOM_SUBSIDY_TYPE,
  GET_ACTIVE_SUBSIDIES,
  GET_SUBSIDIES,
  GET_HISTORY_SUBSIDIES,
  ADD_CUSTOM_SUBSIDY_TO_CHILD,
  VOID_CUSTOM_SUBSIDY,
  APPROVE_CUSTOM_SUBSIDY,
  REJECT_CUSTOM_SUBSIDY,
  CANCEL_CUSTOM_SUBSIDY,
  GET_SUBSIDY_DEBIT_AMOUNT,
  CREATE_ADVANCE_PAYMENT,
  GET_ADVANCE_PAYMENT_RECEIPTS,
  GET_ALL_ABSENT_CHILD_VOID_SUBSIDY,
  REMOVE_CUSTOM_SUBSIDY_BY_CHILD,
  SEARCH_INVOICE,
  EXEMPT_CUSTOM_SUBSIDY_BY_CHILD,
  FIND_CHILD_REFUNDS,
  GET_LIST_OF_ENROLLED_CENTRES,
  CREATE_ADHOC_CHILD_REFUND,
  CANCEL_RECEIPT,
  UNLINK_RECEIPT,
  CREATE_ADVANCE_PAYMENT_FOR_REGISTRATION,
  CREATE_ECDA_ADVANCE_PAYMENT_FOR_REGISTRATION,
  GET_ADVANCE_PAYMENT_ITEM_AMOUNT,
  GET_ADVANCE_PAYMENT_RECEIPTS_FOR_REGISTRATION,
  GET_CHILD_FINANCIAL_ASSISTANCE_STATUS,
  SAVE_REG_GIRO_APPLICATION,
  SAVE_GIRO_APPLICATION,
  UPDATE_BILL_REF_NO,
  GET_CHILD_STATEMENT_OF_ACCOUNT,
  GET_CHILD_SOA_BY_YEAR,
  SAVE_CANCEL_REG_GIRO_APPLICATION,
  EDIT_HISTORY_SUBSIDY,
  LIST_BULK_INVOICES,
  GET_BULK_INVOICE_TEMPLATE,
  CANCEL_BULK_INVOICE,
  VALIDATE_BULK_INVOICE,
  SAVE_BULK_INVOICE,
  UPLOAD_INVOICE_FILE,
  GET_DEBT_WRITE_OFF_REASONS,
  WRITE_OFF_INVOICES,
  GET_PROGRAM_BILLING_MASTER_FILE,
  GET_PROGRAM_BILLING_UPLOAD_TEMPLATE,
  UPLOAD_PROGRAM_BILLING_FILE,
  VALIDATE_PROGRAM_BILLING_REQUEST,
  SAVE_PROGRAM_BILLING_REQUEST,
  LIST_PROGRAM_BILLINGS,
  FIND_ALL_CREDIT_DEBIT_NOTES,
  LIST_REGISTRATION_CHILD_BALANCE_SHEET,
  FIND_ALL_REG_CHILD_REFUNDS,
  LIST_REGISTRATION_TOTAL_ADVANCE_PAYMENTS,
  TRANSFER_CHILD_BALANCE,
  TRANSFER_REG_CHILD_BALANCE,
  UPDATE_REFUND_STATUS,
  ADJUST_INVOICE_AMOUNT_ITEMS_PREVIEW,
  ADJUST_INVOICE_AMOUNT_ITEMS,
  SKIP_GIRO_REG,
  SKIP_PAYMENT_REG,
  CANCEL_ADVANCE_PAYMENT_RECEIPT,
  WRITE_OFF_CREDIT,
  UPDATE_CHILD_TRADE_DEBT_NOTIFY,
  TRADE_DEBT_NOTIFICATIONS,
  HHI_HISTORY,
  UPDATE_CHILD_FINANCIAL_ASSISTANCE,
  GET_CHILD_BALANCE_SHEET,
  FIND_TAX_RATE_AND_AMOUNT,
  MARK_CHECKED_REFUND,
  UNMARK_CHECKED_REFUND,
  CHECKED_REFUND_COUNTS,
  CANCEL_EXPORT_GIRO_REFUND,
  FIND_ALL_CHILD_REFUNDS,
  FIND_ALL_VALID_DOWNLOADED_GIRO_FILES,
  GET_ADVANCE_PAYMENT_RECEIPTS_FOR_ECDA_REGISTRATION,
  GET_ECDA_ADVANCE_PAYMENT_ITEM_AMOUNT,
  SKIP_ECDA_PAYMENT_REG,
  FINANCE_DOC_PDF_URL,
  GET_ID_DOCUMENT_TYPE_CONFIG_BC_URL,
  GET_ID_DOCUMENT_TYPE_CONFIG_ECDA_BC_URL,
  GET_ID_DOCUMENT_TYPE_CONFIG_TEMP_BC_URL,
  GIRO_SIBLING_SELECTION_ACTION,
  SAVE_GIRO_SIBLING_DETAILS,
  FIND_ALL_CHILD_REFUNDS_FOR_ECDA,
  GET_CDA_ACCOUNT_STATEMENT_URL,
  GET_ECDA_CDA_ACCOUNT_STATEMENT_URL,
} from '../models/financeModel';
import { SAVE_REGISTRATION_DOCUMENT } from '../models/documentModelsV2';
import { msGetChildBankAccounts } from '../../services/BankAccountService';
import { msGetDebtWriteOffReasons } from '../../services/SchoolConfigService';
import {
  msFetchInvoiceByFkChild,
  msCreateOfflineInvoice,
  msUpdateBulkInvoiceScheduledTime,
  msGetBulkInvoiceTemplate,
  msValidateAndCreateBulkInvoiceRequest,
  msGetBulkInvoiceUploadURL,
} from '../../services/InvoiceService';
import {
  msGetAllBulkInvoices,
  msUpdateChildFinancialAssistance,
  msGetAllAbsentChildVoidSubsidy,
  msUploadGiroFile,
} from '../../services/FinanceService';
import { msSaveDocument } from '../../services/ChildService';

const fileName = 'redux/actions/Finance.js';
const dispatchFetchAllPurchaseItems = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_PURCHASE_ITEMS,
    key: 'allPurchaseItems',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetChildCurrentBalance = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_CHILD_BALANCE,
    key: 'childBalance',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const statementOfAccountLoading = () => ({
  type: FETCH_STATEMENT_OF_ACCOUNT_LOADING,
  key: 'statementOfAccount',
  value: {
    inProgress: true,
  },
});

const statementOfAccountSuccess = data => ({
  type: FETCH_STATEMENT_OF_ACCOUNT_SUCCESS,
  key: 'statementOfAccount',
  value: {
    inProgress: false,
    data,
  },
});

const statementOfAccountError = error => ({
  type: FETCH_STATEMENT_OF_ACCOUNT_ERROR,
  key: 'statementOfAccount',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const childSOAByYearLoading = () => ({
  type: FETCH_CHILD_SOA_BY_YEAR_LOADING,
  key: 'childSoaByYear',
  value: {
    inProgress: true,
  },
});

const childSOAByYearSuccess = data => ({
  type: FETCH_CHILD_SOA_BY_YEAR_SUCCESS,
  key: 'childSoaByYear',
  value: {
    inProgress: false,
    data,
  },
});

const childSOAByYearError = error => ({
  type: FETCH_CHILD_SOA_BY_YEAR_ERROR,
  key: 'childSoaByYear',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allBulkInvoicesLoading = () => ({
  type: FETCH_ALL_BULK_INVOICES_LOADING,
  key: 'allBulkInvoices',
  value: {
    inProgress: true,
  },
});

const allBulkInvoicesSuccess = data => ({
  type: FETCH_ALL_BULK_INVOICES_SUCCESS,
  key: 'allBulkInvoices',
  value: {
    inProgress: false,
    data,
  },
});

const allBulkInvoicesError = error => ({
  type: FETCH_ALL_BULK_INVOICES_ERROR,
  key: 'allBulkInvoices',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allProgramBillingLoading = () => ({
  type: FETCH_ALL_PGM_BILLING_LOADING,
  key: 'allProgramBillings',
  value: {
    inProgress: true,
  },
});

const allProgramBillingSuccess = data => ({
  type: FETCH_ALL_PGM_BILLING_SUCCESS,
  key: 'allProgramBillings',
  value: {
    inProgress: false,
    data,
  },
});

const allProgramBillingError = error => ({
  type: FETCH_ALL_PGM_BILLING_ERROR,
  key: 'allProgramBillings',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const creditDebitNoteLoading = () => ({
  type: FETCH_CREDIT_DEBIT_NOTE_LOADING,
  key: 'allCreditDebitNotes',
  value: {
    inProgress: true,
  },
});

const creditDebitNoteSuccess = data => ({
  type: FETCH_CREDIT_DEBIT_NOTE_SUCCESS,
  key: 'allCreditDebitNotes',
  value: {
    inProgress: false,
    data,
  },
});

const creditDebitNoteError = error => ({
  type: FETCH_CREDIT_DEBIT_NOTE_ERROR,
  key: 'allCreditDebitNotes',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allRegChildBalanceLoading = () => ({
  type: FETCH_ALL_REG_CHILD_BALANCE_LOADING,
  key: 'allRegChildBalanceSheet',
  value: {
    inProgress: true,
  },
});

const allRegChildBalanceSuccess = data => ({
  type: FETCH_ALL_REG_CHILD_BALANCE_SUCCESS,
  key: 'allRegChildBalanceSheet',
  value: {
    inProgress: false,
    data,
  },
});

const allRegChildBalanceError = error => ({
  type: FETCH_ALL_REG_CHILD_BALANCE_ERROR,
  key: 'allRegChildBalanceSheet',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allChildRefundsLoading = () => ({
  type: FETCH_ALL_CHILD_REFUNDS_LOADING,
  key: 'allChildRefunds',
  value: {
    inProgress: true,
  },
});

const allChildRefundsSuccess = data => ({
  type: FETCH_ALL_CHILD_REFUNDS_SUCCESS,
  key: 'allChildRefunds',
  value: {
    inProgress: false,
    data,
  },
});

const allChildRefundsError = error => ({
  type: FETCH_ALL_CHILD_REFUNDS_ERROR,
  key: 'allChildRefunds',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allRegTotalAdvancePaymentAmountLoading = () => ({
  type: FETCH_ALL_REG_CHILD_TOTAL_ADVANCE_PAYMENTS_LOADING,
  key: 'allRegTotalAdvancePayments',
  value: {
    inProgress: true,
  },
});

const allRegTotalAdvancePaymentAmountSuccess = data => ({
  type: FETCH_ALL_REG_CHILD_TOTAL_ADVANCE_PAYMENTS_SUCCESS,
  key: 'allRegTotalAdvancePayments',
  value: {
    inProgress: false,
    data,
  },
});

const allRegTotalAdvancePaymentAmountError = error => ({
  type: FETCH_ALL_REG_CHILD_TOTAL_ADVANCE_PAYMENTS_ERROR,
  key: 'allRegTotalAdvancePayments',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allAdjustInvoiceAmountLoading = () => ({
  type: FETCH_ADJUST_INVOICE_AMT_LOADING,
  key: 'allAdjustInvoiceAmts',
  value: {
    inProgress: true,
  },
});

const allAdjustInvoiceAmountSuccess = data => ({
  type: FETCH_ADJUST_INVOICE_AMT_SUCCESS,
  key: 'allAdjustInvoiceAmts',
  value: {
    inProgress: false,
    data,
  },
});

const allAdjustInvoiceAmountError = error => ({
  type: FETCH_ADJUST_INVOICE_AMT_ERROR,
  key: 'allAdjustInvoiceAmts',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const tradeDebtNotificationsLoading = () => ({
  type: FETCH_TRADE_DEBT_NOTIFICATION_LOADING,
  key: 'tradeDebtNotifications',
  value: {
    inProgress: true,
  },
});

const tradeDebtNotificationsSuccess = data => ({
  type: FETCH_TRADE_DEBT_NOTIFICATION_SUCCESS,
  key: 'tradeDebtNotifications',
  value: {
    inProgress: false,
    data,
  },
});

const tradeDebtNotificationsError = error => ({
  type: FETCH_TRADE_DEBT_NOTIFICATION_ERROR,
  key: 'tradeDebtNotifications',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const hhiHistoryLoading = () => ({
  type: HHI_HISTORY_LOADING,
  key: 'hhiHistory',
  value: {
    inProgress: true,
  },
});

const hhiHistorySuccess = data => ({
  type: HHI_HISTORY_SUCCESS,
  key: 'hhiHistory',
  value: {
    inProgress: false,
    data,
  },
});

const hhiHistoryError = error => ({
  type: HHI_HISTORY_ERROR,
  key: 'hhiHistory',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const getCurrentChildRefundStatusLoading = () => ({
  type: FETCH_CHILD_REFUND_STATUS_LOADING,
  key: 'checkedRefunds',
  value: {
    inProgress: true,
  },
});

const getCurrentChildRefundStatusSuccess = data => ({
  type: FETCH_CHILD_REFUND_STATUS_SUCCESS,
  key: 'checkedRefunds',
  value: {
    inProgress: false,
    data,
  },
});

const getCurrentChildRefundStatusError = error => ({
  type: FETCH_CHILD_REFUND_STATUS_ERROR,
  key: 'checkedRefunds',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const allRegChildRefundsLoading = () => ({
  type: FETCH_ALL_REG_CHILD_REFUNDS_LOADING,
  key: 'allRegChildRefunds',
  value: {
    inProgress: true,
  },
});

const allRegChildRefundsSuccess = data => ({
  type: FETCH_ALL_REG_CHILD_REFUNDS_SUCCESS,
  key: 'allRegChildRefunds',
  value: {
    inProgress: false,
    data,
  },
});

const allRegChildRefundsError = error => ({
  type: FETCH_ALL_REG_CHILD_REFUNDS_ERROR,
  key: 'allRegChildRefunds',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const historyBillingAdjustmentLoading = () => ({
  type: FETCH_HISTORY_SUBSIDIES_LOADING,
  key: 'allHistorySubsidies',
  value: {
    inProgress: true,
  },
});

const historyBillingAdjustmentSuccess = data => ({
  type: FETCH_HISTORY_SUBSIDIES_SUCCESS,
  key: 'allHistorySubsidies',
  value: {
    inProgress: false,
    data,
  },
});

const historyBillingAdjustmentError = error => ({
  type: FETCH_HISTORY_SUBSIDIES_ERROR,
  key: 'allHistorySubsidies',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const childSubsidiesLoading = () => ({
  type: FETCH_SUBSIDIES_LOADING,
  key: 'allSubsidies',
  value: {
    inProgress: true,
  },
});

const childSubsidiesSuccess = data => ({
  type: FETCH_SUBSIDIES_SUCCESS,
  key: 'allSubsidies',
  value: {
    inProgress: false,
    data,
  },
});

const childSubsidiesError = error => ({
  type: FETCH_SUBSIDIES_ERROR,
  key: 'allSubsidies',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const dispatchGetChildCurrentBalanceSheet = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_CHILD_BALANCE_SHEET,
    key: 'childBalanceInCentre',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchInvoiceByFkChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_INVOICE_BY_FKCHILD,
    key: 'allInvoiceByFkChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllFetchInvoiceByFkChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_INVOICES_BY_CHILD,
    key: 'allInvoicesByChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchChildBankAccounts = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_CHILD_BANK_ACCOUNTS,
    key: 'childBankAccounts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSearchFinance = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_FINANCE,
    key: 'invoiceSearchResult',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSearchInvoice = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_SEARCH_INVOICE,
    key: 'invoiceSearchResult',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAllBanks = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_BANKS,
    key: 'allBanks',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchInvoiceForAllCenter = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_INVOICES_FOR_ALL_CENTRES,
    key: 'allInvoicesForAllCenters',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAllRefunds = (
  dispatch,
  inProgress = true,
  data = {},
  error = null,
  searchMode = false
) => {
  dispatch({
    type: FETCH_CHILD_REFUNDS,
    key: searchMode ? 'refundSearchResult' : 'allRefundData',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchEnrolledCentreList = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ENROLLED_CENTRES,
    key: 'allEnrolledCentres',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllConsolidatedRefund = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_REFUND,
    key: 'allInvoicesWithRefund',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllRefunds = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: ALL_CONSOLIDATED_REFUNDS,
    key: 'allConsolidatedRefunds',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllUploadedSubsidyFiles = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_UPLOADED_SUBSIDY_FILES,
    key: 'allUploadedSubsidyFiles',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetTaxRateAndAmount = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_TAX_RATE_AND_AMOUNT,
    key: 'taxRateAndAmountDetails',
    value: {
      inProgress,
      data,
      error,
    },
  });
};
export const dispatchClearTaxDetails =
  (data = {}) =>
  dispatch => {
    dispatch({
      type: CLEAR_TAX_RATE_AND_AMOUNT,
      key: 'taxRateAndAmountDetails',
      value: data,
    });
  };

const dispatchAllDownloadedGiroFiles = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_DOWNLOADED_GIRO_FILES,
    key: 'allDownloadedGiroFiles',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllValidDownloadedGiroFiles = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_VALID_DOWNLOADED_GIRO_FILES,
    key: 'allValidDownloadedGiroFiles',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllPaymentTypes = (
  dispatch,
  inProgress = true,
  data = [],
  error = null
) => {
  dispatch({
    type: FETCH_PAYMENT_TYPES,
    key: 'allPaymentTypes',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchReasons = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: BANK_ACC_STATUS_CHANGE_REASON_BY_STATUS,
    key: 'allReasonsForChange',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSubsidyTypes = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: ALL_CUSTOM_SUBSIDY_TYPE,
    key: 'allCustomSubsidyTypes',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchActiveSubsidies = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: ACTIVE_SUBSIDIES,
    key: 'allActiveSubsidies',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAdvancePaymentItemAmountForRegistration = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ADVANCE_PAYMENT_ITEM_AMOUNT,
    key: 'allAdvancePaymentItemAmount',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchECDAAdvancePaymentItemAmountForRegistration = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_ADVANCE_PAYMENT_ITEM_AMOUNT,
    key: 'allECDAAdvancePaymentItemAmount',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSubsidyDebitAmount = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: SUBSIDY_DEBIT_AMOUNT,
    key: 'subsidyDebitAmount',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllAbsentChildVoidSubsidy = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: ALL_ABSENT_CHILD_VOID_SUBSIDY,
    key: 'absentChildVoidSubsidy',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const dispatchChildFinancialAssistanceStatus = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_CHILD_FINANCIAL_ASSISTANCE_STATUS,
    key: 'getChildFinancialAssistanceStatus',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAdvancePaymentReceipt = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ADVANCE_PAYMENT_RECEIPTS,
    key: 'allAdvancePaymentReceipts',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchGetAdvancePaymentReceiptForRegistration = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ADVANCE_PAYMENT_RECEIPTS_FOR_REGISTRATION,
    key: 'allAdvancePaymentReceiptsForRegistration',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAdvancePaymentReceiptsForEcdaRegistration = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ADVANCE_PAYMENT_RECEIPTS_FOR_ECDA_REGISTRATION,
    key: 'allECDAAdvancePaymentReceiptsForRegistration',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const dispatchEmptyReason = () => ({
  type: EMPTY_REASONS_GIRO,
  value: {
    inProgress: false,
    data: [],
    error: null,
  },
});

export const monoFetchAllPurchaseItems = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_PURCHASE_ITEM,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoFetchAllPurchaseItems',
      },
      'error'
    );
    const error = parseGraphQLError(ex);
    dispatchFetchInvoiceByFkChild(dispatch, false, null, {
      error,
    });

    throw new Error(error.message);
  }
};

export const fetchAllPurchaseItems = reqData => async dispatch => {
  dispatchFetchAllPurchaseItems(dispatch);

  try {
    const res = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchAllPurchaseItems,
        monoHandler: monoFetchAllPurchaseItems,
        extraData: reqData,
      }
    );

    if (res.success) {
      dispatchFetchAllPurchaseItems(dispatch, false, res);
    } else {
      dispatchFetchAllPurchaseItems(dispatch, false, null, res.error);
    }
  } catch (ex) {
    dispatchFetchAllPurchaseItems(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const getChildCurrentBalance = reqData => async dispatch => {
  dispatchGetChildCurrentBalance(dispatch);
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_CHILD_CURRENT_BALANCE,
        variables: reqData,
      },
      type: 'query',
    });

    if (data.success) {
      dispatchGetChildCurrentBalance(dispatch, false, data);
    } else {
      dispatchGetChildCurrentBalance(dispatch, false, null, data.error);
    }
  } catch (ex) {
    dispatchGetChildCurrentBalance(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const monoGetChildBalanceSheet = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_CHILD_BALANCE_SHEET,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetChildBalanceSheet',
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const getChildCurrentBalanceSheet = reqData => async dispatch => {
  dispatchGetChildCurrentBalanceSheet(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetChildBalanceSheet,
      monoHandler: monoGetChildBalanceSheet,
      extraData: reqData,
    }
  );

  if (resp.success) {
    dispatchGetChildCurrentBalanceSheet(dispatch, false, resp);
  } else {
    dispatchGetChildCurrentBalanceSheet(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoFetchInvoiceByFkChild = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: INVOICES_BY_FK_CHILD,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoFetchInvoiceByFkChild',
      },
      'error'
    );

    dispatchFetchInvoiceByFkChild(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
    return { error: parseGraphQLError(ex) };
  }
};

export const fetchInvoiceByFkChild = reqData => async dispatch => {
  dispatchFetchInvoiceByFkChild(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchInvoiceByFkChild,
        monoHandler: monoFetchInvoiceByFkChild,
        extraData: reqData,
      }
    );

    if (data.success) {
      dispatchFetchInvoiceByFkChild(dispatch, false, data);
    } else {
      dispatchFetchInvoiceByFkChild(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const fetchAllInvoiceByFkChild = IDChild => async dispatch => {
  dispatchAllFetchInvoiceByFkChild(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchInvoiceByFkChild,
        monoHandler: monoFetchInvoiceByFkChild,
        extraData: { IDChild },
      }
    );

    if (data.success) {
      dispatchAllFetchInvoiceByFkChild(dispatch, false, data);
    } else {
      dispatchAllFetchInvoiceByFkChild(dispatch, false, null, data.error);
    }
  } catch (ex) {
    return ex;
  }
};

export const monoSearchFinance = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: SEARCH_FINANCE,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    const error = parseGraphQLError(ex);
    throw new Error(error.message);
  }
};

export const searchFinance = reqData => async dispatch => {
  dispatchSearchFinance(dispatch);

  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msSearchFinance,
        monoHandler: monoSearchFinance,
        extraData: reqData,
      }
    );

    if (data.success) {
      dispatchSearchFinance(dispatch, false, data);
    } else {
      dispatchSearchFinance(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchSearchFinance(dispatch, false, null, {
      error: ex.message || parseGraphQLError(ex),
    });
    return ex.message || parseGraphQLError(ex);
  }
};

export const monoSearchInvoice = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: SEARCH_INVOICE,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    const error = parseGraphQLError(ex);
    throw new Error(error.message);
  }
};

export const searchInvoice = reqData => async dispatch => {
  dispatchSearchFinance(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msSearchInvoice,
        monoHandler: monoSearchInvoice,
        extraData: reqData,
      }
    );

    if (data.success) {
      dispatchSearchInvoice(dispatch, false, data);
    } else {
      dispatchSearchInvoice(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchSearchInvoice(dispatch, false, null, {
      error: ex.message,
    });
    return ex;
  }
};

export const monoFindAllInvoiceForAllCenter = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_INVOICE,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFindAllInvoiceForAllCenter',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchInvoiceForAllCenter = reqData => async dispatch => {
  dispatchFetchInvoiceForAllCenter(dispatch);

  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFindAllInvoiceForAllCenter,
      monoHandler: monoFindAllInvoiceForAllCenter,
      extraData: reqData,
    }
  );

  if (resp.success) {
    dispatchFetchInvoiceForAllCenter(dispatch, false, resp);
  } else {
    dispatchFetchInvoiceForAllCenter(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoFetchAllRefundsList = async (dispatch, reqData) => {
  let searchMode = false;
  if (get(reqData, 'searchMode')) {
    searchMode = true;
  }

  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_CHILD_REFUNDS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    dispatchFetchAllRefunds(
      dispatch,
      false,
      null,
      {
        error: parseGraphQLError(ex),
      },
      searchMode
    );
    return ex;
  }
};

export const fetchAllRefundsList = reqData => async dispatch => {
  try {
    const { searchMode } = reqData;
    dispatchFetchAllRefunds(dispatch, true, null, null, searchMode);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msFetchAllRefundsList,
        monoHandler: monoFetchAllRefundsList,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchFetchAllRefunds(dispatch, false, data.data, null, searchMode);
    } else {
      dispatchFetchAllRefunds(dispatch, false, null, data.error, searchMode);
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const fetchAllEnrolledCentres =
  ({ childID, includeUpComing = true }) =>
  async dispatch => {
    dispatchFetchEnrolledCentreList(dispatch);

    try {
      const data = await SkApolloRequest({
        params: {
          query: GET_LIST_OF_ENROLLED_CENTRES,
          variables: {
            childID,
            includeUpComing,
          },
        },
        type: 'query',
      });

      if (data.success) {
        dispatchFetchEnrolledCentreList(dispatch, false, data.data);
      } else {
        dispatchFetchEnrolledCentreList(dispatch, false, null, data.error);
      }
    } catch (ex) {
      dispatchFetchEnrolledCentreList(dispatch, false, null, {
        error: parseGraphQLError(ex),
      });
    }
  };

export const monoFetchAllConsolidatedRefund = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CONSOLIDATED_REFUND,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const fetchAllConsolidatedRefund = reqData => async dispatch => {
  dispatchAllConsolidatedRefund(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllConsolidatedRefund,
        monoHandler: monoFetchAllConsolidatedRefund,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchAllConsolidatedRefund(dispatch, false, data);
    } else {
      dispatchAllConsolidatedRefund(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchAllConsolidatedRefund(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const monoFetchAllConsoleRefunds = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CONSOLIDATED_REFUND,
        variables: reqData,
      },
      type: 'query',
    });

    if (data.success) {
      dispatchAllRefunds(dispatch, false, data);
    } else {
      dispatchAllRefunds(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const fetchAllConsoleRefunds = reqData => async dispatch => {
  dispatchAllRefunds(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllConsolidatedRefund,
        monoHandler: monoFetchAllConsoleRefunds,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatchAllRefunds(dispatch, false, data);
    } else {
      dispatchAllRefunds(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchAllRefunds(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const monoFetchAllUploadedSubsidyFiles = (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: FIND_ALL_UPLOADED_SUBSIDY_FILES,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAllUploadedSubsidyFiles',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const fetchAllUploadedSubsidyFiles = reqData => async dispatch => {
  dispatchAllUploadedSubsidyFiles(dispatch);
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAllUploadedSubsidyFiles,
      monoHandler: monoFetchAllUploadedSubsidyFiles,
      extraData: reqData,
    }
  );
  if (result.success) {
    dispatchAllUploadedSubsidyFiles(dispatch, false, result.data);
  } else {
    dispatchAllUploadedSubsidyFiles(dispatch, false, null, result.error);
  }
  return result;
};

export const findAllDownloadedGiroFiles =
  (reqData, update = false) =>
  async dispatch => {
    if (!update) {
      dispatchAllDownloadedGiroFiles(dispatch);
    }
    try {
      const result = await SkApolloRequest({
        params: {
          query: FIND_ALL_DOWNLOADED_GIRO_FILES,
          variables: reqData,
        },
        type: 'query',
      });
      if (!update) {
        if (result.success) {
          dispatchAllDownloadedGiroFiles(dispatch, false, result.data);
        } else {
          dispatchAllDownloadedGiroFiles(dispatch, false, null, result.error);
        }
      }
      return result;
    } catch (ex) {
      dispatchAllDownloadedGiroFiles(dispatch, false, null, {
        error: parseGraphQLError(ex),
      });
    }
  };

export const monoFindAllValidDownloadedGiroFiles = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: FIND_ALL_VALID_DOWNLOADED_GIRO_FILES,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFindAllValidDownloadedGiroFiles',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const findAllValidDownloadedGiroFiles =
  (reqData, update = false) =>
  async dispatch => {
    if (!update) {
      dispatchAllValidDownloadedGiroFiles(dispatch);
    }
    try {
      const result = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msFindAllValidDownloadedGiroFiles,
          monoHandler: monoFindAllValidDownloadedGiroFiles,
          extraData: reqData,
        }
      );
      if (!update) {
        if (result.success) {
          dispatchAllValidDownloadedGiroFiles(dispatch, false, result.data);
        } else {
          dispatchAllValidDownloadedGiroFiles(
            dispatch,
            false,
            null,
            result.error
          );
        }
      }
      return result;
    } catch (ex) {
      dispatchAllValidDownloadedGiroFiles(dispatch, false, null, {
        error: parseGraphQLError(ex),
      });
    }
  };

export const monoGetTaxRateAndAmount = async (_, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: FIND_TAX_RATE_AND_AMOUNT,
        variables: reqData,
      },
      type: 'query',
    });

    return result;
  } catch (ex) {
    throw parseGraphQLError(ex);
  }
};

export const getTaxRateAndAmount = reqData => async dispatch => {
  dispatchGetTaxRateAndAmount(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msGetTaxRateAndAmount,
        monoHandler: monoGetTaxRateAndAmount,
        extraData: reqData,
      }
    );

    if (result.success) {
      dispatchGetTaxRateAndAmount(dispatch, false, result.data);
    } else {
      dispatchGetTaxRateAndAmount(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    dispatchGetTaxRateAndAmount(dispatch, false, null, {
      error: ex,
    });
  }
};

export const monoGetFinanceDocumentUploadURL = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_FINANCE_DOCUMENT_UPLOAD_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const getFinanceDocumentUploadURL = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetFinanceDocumentUploadURL,
    monoHandler: monoGetFinanceDocumentUploadURL,
    extraData: reqData,
  });

export const monoCreateAdhocChildRefund = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CREATE_ADHOC_CHILD_REFUND,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateAdhocChildRefund',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const createAdhocChildRefund = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msCreateAdhocChildRefund,
    monoHandler: monoCreateAdhocChildRefund,
    extraData: reqData,
  });

export const monoUploadSubsidyFile = async (_, reqData) => {
  try {
    const { IDSchool, url, filename } = reqData;
    const result = await SkApolloRequest({
      params: {
        mutation: UPLOAD_SUBISDY_FILE,
        variables: { IDSchool, url, filename },
      },
      type: 'mutation',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoUploadSubsidyFile',
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const uploadSubsidyFile = (IDSchool, url, filename) => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUploadSubsidyFile,
      monoHandler: monoUploadSubsidyFile,
      extraData: { IDSchool, url, filename },
    }
  );
};

export const monoUpdateBankAccountStatus = reqData => async () => {
  try {
    const result = await SkApolloRequest({
      params: {
        mutation: UPDATE_GIRO_STATUS_WITH_REASON_MODEL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoUpdateBankAccountStatus',
        fileName: 'src/redux/actions/Finance.js',
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const updateBankAccountStatus = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUpdateBankAccountStatus,
      monoHandler: monoUpdateBankAccountStatus,
      extraData: reqData,
    }
  );
};

export const monoUploadGiroFile = async (_, reqData) => {
  try {
    const { IDSchool, url, filename, docType, IDRequestFinanceDocument } =
      reqData;
    return SkApolloRequest({
      params: {
        mutation: UPLOAD_GIRO_FILE,
        variables: {
          IDSchool,
          url,
          filename,
          docType,
          IDRequestFinanceDocument,
        },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoUploadGiroFile',
        fileName,
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const uploadGiroFile =
  (IDSchool, url, filename, docType, IDRequestFinanceDocument) => async () =>
    actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
      msHandler: msUploadGiroFile,
      monoHandler: monoUploadGiroFile,
      extraData: {
        url,
        IDSchool,
        filename,
        docType,
        IDRequestFinanceDocument,
      },
    });

export const monoGetGiroRefundArchive = async (_, reqData) => {
  try {
    const IDSchool = get(reqData, 'IDSchool');
    const result = await SkApolloRequest({
      params: {
        mutation: GENERATE_GIRO_REFUND_ARCHIVE,
        variables: {
          IDSchool,
        },
      },
      type: 'mutation',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetGiroRefundArchive',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getGiroRefundArchive = IDSchool => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGenerateGiroRefund,
      monoHandler: monoGetGiroRefundArchive,
      extraData: { IDSchool },
    }
  );
};

export const monoGetGiroDeductionArchive = async (_, reqData) => {
  try {
    const IDSchool = get(reqData, 'IDSchool');
    const result = await SkApolloRequest({
      params: {
        mutation: GENERATE_GIRO_DEDUCTION_ARCHIVE,
        variables: {
          IDSchool,
        },
      },
      type: 'mutation',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetGiroDeductionArchive',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getGiroDeductionArchive = IDSchool => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGenerateGiroDeduction,
      monoHandler: monoGetGiroDeductionArchive,
      extraData: { IDSchool },
    }
  );
};

export const monoExportGiroApplicationPdf = async (_, reqData) => {
  try {
    const bankAccountID = get(reqData, 'bankAccountID');
    const centreId = get(reqData, 'centreId');

    const result = await SkApolloRequest({
      params: {
        mutation: EXPORT_GIRO_APPLICATION_PDF,
        variables: {
          bankAccountID,
          centreId,
        },
      },
      type: 'mutation',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoExportGiroApplicationPdf',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const exportGiroApplicationPdf =
  ({ bankAccountID, centreId }) =>
  () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msExportGiroPdf,
        monoHandler: monoExportGiroApplicationPdf,
        extraData: { bankAccountID, centreId },
      }
    );
  };

export const monoCreateOfflineInvoice = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CREATE_OFFLINE_INVOICE,
        variables: reqData,
      },
      type: 'mutation',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateOfflineInvoice',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const createOfflineInvoice = reqData => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msCreateOfflineInvoice,
        monoHandler: monoCreateOfflineInvoice,
        extraData: reqData,
      }
    );

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoCreateOfflineReceipt = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CREATE_RECEIPT_FOR_OFFLINE_PAYMENT,
        variables: reqData,
      },
      type: 'mutation',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateOfflineReceipt',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const createOfflineReceipt = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msCreateOfflineReceipt,
    monoHandler: monoCreateOfflineReceipt,
    extraData: reqData,
  });

export const monoCreateAdHocCreditNote = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CREATE_ADHOC_CREDIT_NOTE,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const createAdHocCreditNote = reqData => async dispatch => {
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msCreateAdHocCreditNote,
        monoHandler: monoCreateAdHocCreditNote,
        extraData: reqData,
      }
    );
    return result;
  } catch (ex) {
    return ex;
  }
};

export const monoCancelReceipt = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CANCEL_RECEIPT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const cancelReceipt = reqData => async dispatch => {
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msCancelReceipt,
        monoHandler: monoCancelReceipt,
        extraData: reqData,
      }
    );
    return result;
  } catch (ex) {
    return ex;
  }
};

export const monoUnlinkReceipt = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UNLINK_RECEIPT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const unlinkReceipt = reqData => async dispatch => {
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msUnlinkReceipt,
        monoHandler: monoUnlinkReceipt,
        extraData: reqData,
      }
    );
    return result;
  } catch (ex) {
    return ex;
  }
};

export const monoGetChildBankAccounts = async (dispatch, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: BANK_ACCOUNTS_INFO_BY_CHILD_ID,
        variables: reqData,
      },
      type: 'query',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetChildBankAccounts',
      },
      'error'
    );

    dispatchFetchChildBankAccounts(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
    return ex;
  }
};

export const getChildBankAccounts = reqData => async dispatch => {
  dispatchFetchChildBankAccounts(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetChildBankAccounts,
        monoHandler: monoGetChildBankAccounts,
        extraData: reqData,
      }
    );

    if (result.success) {
      dispatchFetchChildBankAccounts(dispatch, false, result.data);
    } else {
      dispatchFetchChildBankAccounts(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    return ex;
  }
};

export const monoGetAllBanks = async (_, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: FIND_ALL_BANK_BIC_CODE,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetAllBanks',
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAllBanks = reqData => async dispatch => {
  dispatchFetchAllBanks(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetAllBankBicCodes,
      monoHandler: monoGetAllBanks,
      extraData: reqData,
    }
  );

  if (data.success) {
    dispatchFetchAllBanks(dispatch, false, data.data);
  } else {
    dispatchFetchAllBanks(dispatch, false, null, data.error);
  }

  return data;
};

export const monoSaveGiroApplication = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SAVE_GIRO_APPLICATION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSaveGiroApplication',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const saveGiroApplication = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSaveGiroApplication,
      monoHandler: monoSaveGiroApplication,
      extraData: reqData,
    }
  );
};

export const monoSaveRegGiroApplication = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SAVE_REG_GIRO_APPLICATION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSaveRegGiroApplication',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const saveRegGiroApplication = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSaveRegGiroApplication,
      monoHandler: monoSaveRegGiroApplication,
      extraData: reqData,
    }
  );
};

export const saveCancelRegistrationGiroAccounts = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SAVE_CANCEL_REG_GIRO_APPLICATION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const getGiroDocumentUploadUrl = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_ID_DOCUMENT_TYPE_CONFIG_UPLOAD_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const monoGetGiroFormUploadURL = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_ID_DOCUMENT_TYPE_CONFIG_GIRO_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetGiroFormUploadURL',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getGiroFormUploadURL = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetGiroFormUploadURL,
      monoHandler: monoGetGiroFormUploadURL,
      extraData: reqData,
    }
  );
};

export const monoGetSiblingBirthCertificateUploadURL = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_ID_DOCUMENT_TYPE_CONFIG_BC_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetSiblingBirthCertificateUploadURL',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getSiblingBirthCertificateUploadURL = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetSiblingBirthCertificateUploadURL,
      monoHandler: monoGetSiblingBirthCertificateUploadURL,
      extraData: reqData,
    }
  );
};

export const monoGetEcdaSiblingBirthCertificateUploadURL = async (
  _,
  reqData
) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: GET_ID_DOCUMENT_TYPE_CONFIG_ECDA_BC_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetEcdaSiblingBirthCertificateUploadURL',
        fileName,
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const getEcdaSiblingBirthCertificateUploadURL = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetEcdaSiblingBirthCertificateUploadURL,
    monoHandler: monoGetEcdaSiblingBirthCertificateUploadURL,
    extraData: reqData,
  });

export const monoGetCdaAccountStatementUploadURL = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_CDA_ACCOUNT_STATEMENT_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetCdaAccountStatementUploadURL',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getCdaAccountStatementUploadURL = reqData => () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetCdaAccountStatementUploadURL,
      monoHandler: monoGetCdaAccountStatementUploadURL,
      extraData: reqData,
    }
  );
};

export const monoGetEcdaCdaAccountStatementUploadURL = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: GET_ECDA_CDA_ACCOUNT_STATEMENT_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetEcdaCdaAccountStatementUploadURL',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getEcdaCdaAccountStatementUploadURL = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetEcdaCdaAccountStatementUploadURL,
      monoHandler: monoGetEcdaCdaAccountStatementUploadURL,
      extraData: reqData,
    }
  );
};

export const monoGetSiblingBirthCertificateTempUploadURL = async (
  _,
  reqData
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_ID_DOCUMENT_TYPE_CONFIG_TEMP_BC_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetSiblingBirthCertificateTempUploadURL',
        fileName,
      },
      'error'
    );
    return { success: false, error: parseGraphQLError(ex) };
  }
};

export const getSiblingBirthCertificateTempUploadURL = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetSiblingBirthCertificateTempUploadURL,
    monoHandler: monoGetSiblingBirthCertificateTempUploadURL,
    extraData: reqData,
  });

export const getGiroDocumentUploadUrls = reqData => async () => {
  try {
    const bulkMutationReqData = (reqData || []).map(item => ({
      queryKey: `documentUpload${item.type}`,
      key: 'getDocumentUploadURLByIDDocumentTypeConfig',
      query: '{ Url, Key, Filename }',
      variables: [
        {
          IDDocumentTypeConfig: item.IDDocumentTypeConfig,
          IDRegChild: item.IDRegChild,
          file: {
            filename: item.file.name,
            filepath: item.file.path,
            filesize: item.file.size,
            mimetype: item.file.type,
          },
        },
      ],
    }));
    const response = await SkApolloRequest({
      params: bulkMutationReqData,
      type: 'bulkMutation',
    });
    return response;
  } catch (ex) {
    return ex;
  }
};

export const monoSaveGiroOfflineDocument = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: SAVE_DOCUMENT,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSaveGiroOfflineDocument',
        fileName,
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const saveGiroOfflineDocument = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msSaveDocument,
    monoHandler: monoSaveGiroOfflineDocument,
    extraData: reqData,
  });

export const saveRegistrationGiroDocument = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch: null,
      msHandler: msSaveUploadedRegDocument,
      monoHandler: async () => {
        try {
          const data = await SkApolloRequest({
            params: {
              mutation: SAVE_REGISTRATION_DOCUMENT,
              variables: reqData,
            },
            type: 'mutation',
          });
          return data;
        } catch (ex) {
          DatadogHandler.addError(ex);
          DatadogHandler.sendLog(
            ex,
            {
              functionName: 'saveRegistrationGiroDocument',
              fileName,
            },
            'error'
          );
          return {
            success: false,
            error: parseGraphQLError(ex),
          };
        }
      },
      extraData: reqData,
    }
  );
};

export const monoGiroSiblingSelectionAction = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GIRO_SIBLING_SELECTION_ACTION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGiroSiblingSelectionAction',
        fileName,
      },
      'error'
    );
    return { success: false, error: parseGraphQLError(ex) };
  }
};

export const giroSiblingSelectionAction = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGiroSiblingSelectionAction,
    monoHandler: monoGiroSiblingSelectionAction,
    extraData: reqData,
  });

export const saveGiroSiblingDetails = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SAVE_GIRO_SIBLING_DETAILS,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const monoFetchAllPaymentTypes = async (_, reqData) => {
  try {
    const schoolID = get(reqData, 'schoolID');
    const result = await SkApolloRequest({
      params: {
        query: PAYMENT_TYPES,
        variables: schoolID,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAllPaymentTypes',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchAllPaymentTypes = schoolID => async dispatch => {
  dispatchAllPaymentTypes(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAllPaymentTypes,
      monoHandler: monoFetchAllPaymentTypes,
      extraData: { schoolID },
    }
  );
  if (resp.success) {
    dispatchAllPaymentTypes(dispatch, false, resp.data);
  } else {
    dispatchAllPaymentTypes(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoGetBankAccountStatusChangeReasonsByStatus = async (
  _,
  reqData
) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_BANK_ACC_STATUS_CHANGE_REASON_BY_STATUS,
        variables: reqData,
      },
      type: 'query',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetBankAccountStatusChangeReasonsByStatus',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getBankAccountStatusChangeReasonsByStatus =
  reqData => async dispatch => {
    dispatchReasons(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetBankAccountStatusChangeReasonsByStatus,
        monoHandler: monoGetBankAccountStatusChangeReasonsByStatus,
        extraData: reqData,
      }
    );
    if (resp.success) {
      dispatchReasons(dispatch, false, resp.data);
    } else {
      dispatchReasons(dispatch, false, null, resp.error);
    }
    return resp;
  };

export const monoGetAllCustomSubsidyType = async (dispatch, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_ALL_CUSTOM_SUBSIDY_TYPE,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    dispatchSubsidyTypes(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllCustomSubsidyType',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getAllCustomSubsidyType = reqData => async dispatch => {
  dispatchSubsidyTypes(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllCustomSubsidyType,
        monoHandler: monoGetAllCustomSubsidyType,
        extraData: reqData,
      }
    );
    if (result.success) {
      dispatchSubsidyTypes(dispatch, false, result.data);
    } else {
      dispatchSubsidyTypes(dispatch, false, null, result.error);
    }
  } catch (ex) {
    return ex;
  }
};

export const monoGetAllActiveSubsidies = async (dispatch, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_ACTIVE_SUBSIDIES,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    dispatchActiveSubsidies(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllActiveSubsidies',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const getAllActiveSubsidies = reqData => async dispatch => {
  dispatchActiveSubsidies(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllActiveSubsidies,
        monoHandler: monoGetAllActiveSubsidies,
        extraData: reqData,
      }
    );
    if (result.success) {
      dispatchActiveSubsidies(dispatch, false, result.data);
    } else {
      dispatchActiveSubsidies(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    return ex;
  }
};

export const monoGetHistoryBillingAdjustments = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_HISTORY_SUBSIDIES,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    dispatch(historyBillingAdjustmentError(ex.ex.message));
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetHistoryBillingAdjustments',
        fileName,
      },
      'error'
    );
    return { error: ex.ex.message };
  }
};

export const getHistoryBillingAdjustments = reqData => async dispatch => {
  dispatch(historyBillingAdjustmentLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetHistoryBillingAdjustments,
        monoHandler: monoGetHistoryBillingAdjustments,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatch(historyBillingAdjustmentSuccess(data.data));
    } else {
      dispatch(historyBillingAdjustmentError(data.error));
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getAllChildHistorySubsidies = reqData => async dispatch => {
  dispatch(childSubsidiesLoading());
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_SUBSIDIES,
        variables: reqData,
      },
      type: 'query',
    });
    if (data.success) {
      dispatch(childSubsidiesSuccess(data.data));
    } else {
      dispatch(childSubsidiesError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(childSubsidiesError(ex.ex.message));
  }
};

export const monoGetAdvancePaymentItemAmountForRegistration = async (
  _,
  reqData
) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_ADVANCE_PAYMENT_ITEM_AMOUNT,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAdvancePaymentItemAmountForRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getAdvancePaymentItemAmountForRegistration =
  reqData => async dispatch => {
    dispatchAdvancePaymentItemAmountForRegistration(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAdvancePaymentItemAmountForRegistration,
        monoHandler: monoGetAdvancePaymentItemAmountForRegistration,
        extraData: reqData,
      }
    );
    if (resp.success) {
      dispatchAdvancePaymentItemAmountForRegistration(
        dispatch,
        false,
        resp.data
      );
    } else {
      dispatchAdvancePaymentItemAmountForRegistration(
        dispatch,
        false,
        null,
        resp.error
      );
    }
    return resp;
  };

export const monoGetECDAAdvancePaymentItemAmountForRegistration = async (
  _,
  reqData
) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_ECDA_ADVANCE_PAYMENT_ITEM_AMOUNT,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDAAdvancePaymentItemAmountForRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getECDAAdvancePaymentItemAmountForRegistration =
  reqData => async dispatch => {
    dispatchECDAAdvancePaymentItemAmountForRegistration(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetECDAAdvancePaymentItemAmountForRegistration,
        monoHandler: monoGetECDAAdvancePaymentItemAmountForRegistration,
        extraData: reqData,
      }
    );
    if (resp.success) {
      dispatchECDAAdvancePaymentItemAmountForRegistration(
        dispatch,
        false,
        resp.data
      );
    } else {
      dispatchECDAAdvancePaymentItemAmountForRegistration(
        dispatch,
        false,
        null,
        resp.error
      );
    }
    return resp;
  };

export const monoCreateCustomSubsidy = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: ADD_CUSTOM_SUBSIDY_TO_CHILD,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const createCustomSubsidy = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msCreateCustomSubsidy,
    monoHandler: monoCreateCustomSubsidy,
    extraData: reqData,
  });

export const monoCreateAdvancePaymentReceipt = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CREATE_ADVANCE_PAYMENT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const createAdvancePaymentReceipt = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCreateAdvancePaymentReceipt,
      monoHandler: monoCreateAdvancePaymentReceipt,
      extraData: reqData,
    }
  );
};

export const monoCreateAdvancePaymentReceiptForRegistration = async (
  _,
  reqData
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CREATE_ADVANCE_PAYMENT_FOR_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateAdvancePaymentReceiptForRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const createAdvancePaymentReceiptForRegistration =
  reqData => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msCreateAdvancePaymentReceiptForRegistration,
        monoHandler: monoCreateAdvancePaymentReceiptForRegistration,
        extraData: reqData,
      }
    );
  };

export const monoCreateECDAAdvancePaymentReceiptForRegistration = async (
  _,
  reqData
) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CREATE_ECDA_ADVANCE_PAYMENT_FOR_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateECDAAdvancePaymentReceiptForRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const createECDAAdvancePaymentReceiptForRegistration =
  reqData => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msCreateECDAAdvancePaymentReceiptForRegistration,
        monoHandler: monoCreateECDAAdvancePaymentReceiptForRegistration,
        extraData: reqData,
      }
    );
  };

export const monoVoidCustomSubsidy = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: VOID_CUSTOM_SUBSIDY,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoVoidCustomSubsidy',
        fileName,
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const voidCustomSubsidy = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msVoidCustomSubsidy,
    monoHandler: monoVoidCustomSubsidy,
    extraData: reqData,
  });

export const monoApproveCustomSubsidy = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: APPROVE_CUSTOM_SUBSIDY,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoApproveCustomSubsidy',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const approveCustomSubsidy = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msApproveCustomSubsidy,
      monoHandler: monoApproveCustomSubsidy,
      extraData: reqData,
    }
  );
};

export const monoRejectCustomSubsidy = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: REJECT_CUSTOM_SUBSIDY,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoRejectCustomSubsidy',
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const rejectCustomSubsidy = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msRejectCustomSubsidy,
    monoHandler: monoRejectCustomSubsidy,
    extraData: reqData,
  });

const monoCancelCustomSubsidy = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CANCEL_CUSTOM_SUBSIDY,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const cancelCustomSubsidy = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelCustomSubsidy,
      monoHandler: monoCancelCustomSubsidy,
      extraData: reqData,
    }
  );
};

export const monoGetSubsidyDebitNoteAmount = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_SUBSIDY_DEBIT_AMOUNT,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetSubsidyDebitNoteAmount',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const getSubsidyDebitNoteAmount = reqData => async dispatch => {
  dispatchSubsidyDebitAmount(dispatch);
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetSubsidyDebitNoteAmount,
      monoHandler: monoGetSubsidyDebitNoteAmount,
      extraData: reqData,
    }
  );

  if (result.success) {
    dispatchSubsidyDebitAmount(dispatch, false, result.data);
  } else {
    dispatchSubsidyDebitAmount(dispatch, false, null, result.error);
  }
};

export const monoFetchAdvancePaymentReceipts = async (dispatch, reqData) => {
  dispatchGetAdvancePaymentReceipt(dispatch);
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_ADVANCE_PAYMENT_RECEIPTS,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    dispatchGetAdvancePaymentReceipt(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const fetchAdvancePaymentReceipts = reqData => async dispatch => {
  dispatchGetAdvancePaymentReceiptForRegistration(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAdvancePaymentReceipts,
      monoHandler: monoFetchAdvancePaymentReceipts,
      extraData: reqData,
    }
  );
  if (resp?.success) {
    dispatchGetAdvancePaymentReceipt(dispatch, false, resp.data);
  } else {
    dispatchGetAdvancePaymentReceipt(dispatch, false, null, resp.error);
  }
};

export const monoFetchAdvancePaymentReceiptsForRegistration = async (
  _,
  reqData
) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_ADVANCE_PAYMENT_RECEIPTS_FOR_REGISTRATION,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAdvancePaymentReceiptsForRegistration',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchAdvancePaymentReceiptsForRegistration =
  reqData => async dispatch => {
    dispatchGetAdvancePaymentReceiptForRegistration(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchAdvancePaymentReceiptsForRegistration,
        monoHandler: monoFetchAdvancePaymentReceiptsForRegistration,
        extraData: reqData,
      }
    );

    if (resp.success) {
      dispatchGetAdvancePaymentReceiptForRegistration(
        dispatch,
        false,
        resp.data
      );
    } else {
      dispatchGetAdvancePaymentReceiptForRegistration(
        dispatch,
        false,
        null,
        resp.error
      );
    }
    return resp;
  };

export const monoGetAllAbsentChildVoidSubsidy = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_ALL_ABSENT_CHILD_VOID_SUBSIDY,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllAbsentChildVoidSubsidy',
        fileName,
      },
      'error'
    );
    return ex;
  }
};

export const getAllAbsentChildVoidSubsidy = reqData => async dispatch => {
  dispatchAllAbsentChildVoidSubsidy(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllAbsentChildVoidSubsidy,
        monoHandler: monoGetAllAbsentChildVoidSubsidy,
        extraData: reqData,
      }
    );
    if (result.success) {
      dispatchAllAbsentChildVoidSubsidy(dispatch, false, result.data);
    } else {
      dispatchAllAbsentChildVoidSubsidy(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    dispatchAllAbsentChildVoidSubsidy(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
    return ex;
  }
};

export const monoGetChildFinancialAssistanceStatus = async (_, reqData) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_CHILD_FINANCIAL_ASSISTANCE_STATUS,
        variables: reqData,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetChildFinancialAssistanceStatus',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getChildFinancialAssistanceStatus = reqData => async dispatch => {
  dispatchChildFinancialAssistanceStatus(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetChildFinancialAssistanceStatus,
        monoHandler: monoGetChildFinancialAssistanceStatus,
        extraData: reqData,
      }
    );
    if (result.success) {
      dispatchChildFinancialAssistanceStatus(dispatch, false, result.data);
    } else {
      dispatchChildFinancialAssistanceStatus(
        dispatch,
        false,
        null,
        result.error
      );
    }
    return result;
  } catch (ex) {
    dispatchChildFinancialAssistanceStatus(dispatch, false, null, {
      error: ex.message,
    });
    return ex;
  }
};

export const monoUpdateChildFinancialAssistance = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: UPDATE_CHILD_FINANCIAL_ASSISTANCE,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      { functionName: 'monoUpdateChildFinancialAssistance', fileName },
      'error'
    );
    return ex;
  }
};

export const updateChildFinancialAssistance = reqData => async () => {
  try {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msUpdateChildFinancialAssistance,
        monoHandler: monoUpdateChildFinancialAssistance,
        extraData: reqData,
      }
    );
  } catch (error) {
    return parseGraphQLError(error);
  }
};

const monoRemoveCustomSubsidy = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: REMOVE_CUSTOM_SUBSIDY_BY_CHILD,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const removeCustomSubsidy = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msRemoveCustomSubsidy,
      monoHandler: monoRemoveCustomSubsidy,
      extraData: reqData,
    }
  );
};

const monoExemptCustomSubsidy = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: EXEMPT_CUSTOM_SUBSIDY_BY_CHILD,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const exemptCustomSubsidy = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msExemptCustomSubsidy,
      monoHandler: monoExemptCustomSubsidy,
      extraData: reqData,
    }
  );
};

export const monoUpdateBankAccountBillRefNumber = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: UPDATE_BILL_REF_NO,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      { functionName: 'monoUpateBankAccountBillRefNumber', fileName },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const updateBankAccountBillRefNumber = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUpdateBankAccountBillRefNumber,
      monoHandler: monoUpdateBankAccountBillRefNumber,
      extraData: reqData,
    }
  );
};

export const monoEditHistorySubsidy = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: EDIT_HISTORY_SUBSIDY,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const editHistorySubsidy = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msEditHistorySubsidy,
    monoHandler: monoEditHistorySubsidy,
    extraData: reqData,
  });

export const getChildStatementOfAccounts = reqData => async dispatch => {
  dispatch(statementOfAccountLoading());
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_CHILD_STATEMENT_OF_ACCOUNT,
        variables: reqData,
      },
      type: 'query',
    });
    if (data.success) {
      dispatch(statementOfAccountSuccess(data.data));
    } else {
      dispatch(statementOfAccountError(data.error));
    }
  } catch (ex) {
    dispatch(statementOfAccountError(ex.ex.message));
  }
};

export const monoGetChildSOAByYear = async (dispatch, reqData) => {
  dispatch(childSOAByYearLoading());
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_CHILD_SOA_BY_YEAR,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getChildSOAByYear = reqData => async dispatch => {
  dispatch(childSOAByYearLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetChildSOAByYear,
        monoHandler: monoGetChildSOAByYear,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatch(childSOAByYearSuccess(data.data));
    } else {
      dispatch(childSOAByYearError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(childSOAByYearError(ex.ex.message));
    return ex;
  }
};

export const monoGetAllBulkInvoices = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: LIST_BULK_INVOICES,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      { functionName: 'monoGetAllBulkInvoices', fileName },
      'error'
    );
    return {
      success: false,
      error: ex?.ex?.message,
    };
  }
};

export const getAllBulkInvoices = reqData => async dispatch => {
  dispatch(allBulkInvoicesLoading());
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetAllBulkInvoices,
      monoHandler: monoGetAllBulkInvoices,
      extraData: reqData,
    }
  );
  if (resp?.success) {
    dispatch(allBulkInvoicesSuccess(resp.data));
  } else {
    dispatch(allBulkInvoicesError(resp.error));
  }
  return resp;
};

export const monoGetBulkInvoiceTemplate = async () => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_BULK_INVOICE_TEMPLATE,
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      { functionName: 'monoGetBulkInvoiceTemplate', fileName },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const getBulkInvoiceTemplate = () => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetBulkInvoiceTemplate,
    monoHandler: monoGetBulkInvoiceTemplate,
  });

export const monoCancelBulkInvoiceRequest = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CANCEL_BULK_INVOICE,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const cancelBulkInvoiceRequest = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelBulkInvoiceRequest,
      monoHandler: monoCancelBulkInvoiceRequest,
      extraData: reqData,
    }
  );
};

export const monoValidateAndCreateBulkInvoiceRequest = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: VALIDATE_BULK_INVOICE,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      { functionName: 'monoValidateAndCreateBulkInvoiceRequest', fileName },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const validateAndCreateBulkInvoiceRequest = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msValidateAndCreateBulkInvoiceRequest,
    monoHandler: monoValidateAndCreateBulkInvoiceRequest,
    extraData: reqData,
  });

export const monoUpdateBulkInvoiceScheduledTime = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SAVE_BULK_INVOICE,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      { functionName: 'monoUpdateBulkInvoiceScheduledTime', fileName },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const updateBulkInvoiceScheduledTime = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msUpdateBulkInvoiceScheduledTime,
    monoHandler: monoUpdateBulkInvoiceScheduledTime,
    extraData: reqData,
  });

export const monoGetBulkInvoiceUploadURL = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: UPLOAD_INVOICE_FILE,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetBulkInvoiceUploadURL',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getBulkInvoiceUploadURL = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetBulkInvoiceUploadURL,
      monoHandler: monoGetBulkInvoiceUploadURL,
      extraData: reqData,
    }
  );
};

const debtWriteOffReasonsLoading = () => ({
  type: FETCH_DEBT_WRITE_OFF_LOADING,
  key: 'debtWriteOffReasons',
  value: {
    inProgress: true,
  },
});

const debtWriteOffReasonsSuccess = data => ({
  type: FETCH_DEBT_WRITE_OFF_SUCCESS,
  key: 'debtWriteOffReasons',
  value: {
    inProgress: false,
    data,
  },
});

const debtWriteOffReasonsError = error => ({
  type: FETCH_DEBT_WRITE_OFF_ERROR,
  key: 'debtWriteOffReasons',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

export const monoGetDebtWriteOffReasons = async (dispatch, { schoolID }) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_DEBT_WRITE_OFF_REASONS,
        variables: schoolID,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetDebtWriteOffReasons',
        fileName,
      },
      'error'
    );
    dispatch(debtWriteOffReasonsError(ex.ex.message));
    return { error: ex.message };
  }
};

export const getDebtWriteOffReasons = schoolID => async dispatch => {
  dispatch(debtWriteOffReasonsLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetDebtWriteOffReasons,
        monoHandler: monoGetDebtWriteOffReasons,
        extraData: { schoolID },
      }
    );
    if (data.success) {
      dispatch(debtWriteOffReasonsSuccess(data.data));
    } else {
      dispatch(debtWriteOffReasonsError(data.error));
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoWriteOffInvoices = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: WRITE_OFF_INVOICES,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoWriteOffInvoices',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const writeOffInvoices = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msWriteOffInvoices,
    monoHandler: monoWriteOffInvoices,
    extraData: reqData,
  });

export const monoExportProgramBillingMasterFile = forDsp => async () => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_PROGRAM_BILLING_MASTER_FILE,
        variables: forDsp,
      },
      type: 'query',
    });
  } catch (ex) {
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const exportProgramBillingMasterFile = forDsp => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msExportProgramBillingMasterFile,
      monoHandler: monoExportProgramBillingMasterFile,
      extraData: forDsp,
    }
  );
};

export const monoExportProgramBillingUploadTemplate = async () => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_PROGRAM_BILLING_UPLOAD_TEMPLATE,
        variables: { forDsp: false },
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const exportProgramBillingUploadTemplate = () => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msExportProgramBillingUploadTemplate,
        monoHandler: monoExportProgramBillingUploadTemplate,
      }
    );

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoGetProgramBillingUploadURL = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UPLOAD_PROGRAM_BILLING_FILE,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const getProgramBillingUploadURL = reqData => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msGetProgramBillingUploadURL,
        monoHandler: monoGetProgramBillingUploadURL,
        extraData: reqData,
      }
    );

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoValidateProgramBillingRequest = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: VALIDATE_PROGRAM_BILLING_REQUEST,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    const error = parseGraphQLError(ex);
    throw error;
  }
};

export const validateProgramBillingRequest = reqData => async dispatch => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msValidateProgramBillingRequest,
        monoHandler: monoValidateProgramBillingRequest,
        extraData: reqData,
      }
    );

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoCreateProgramBillingRequest = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SAVE_PROGRAM_BILLING_REQUEST,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const createProgramBillingRequest = reqData => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msCreateProgramBillingRequest,
        monoHandler: monoCreateProgramBillingRequest,
        extraData: reqData,
      }
    );

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoGetDebtWriteOffDocUploadUrls = async (_, reqData) => {
  try {
    const bulkMutationReqData = (reqData || []).map((item, idx) => ({
      queryKey: `docUpload${idx + 1}`,
      key: 'getDebtWriteOffSupportingDocumentUploadURL',
      query: '{ Url, Key, Filename }',
      variables: [
        {
          file: {
            filename: item.file.name,
            filepath: item.file.path,
            filesize: item.file.size,
            mimetype: item.file.type,
          },
        },
      ],
    }));
    const response = await SkApolloRequest({
      params: bulkMutationReqData,
      type: 'bulkMutation',
    });
    return response;
  } catch (ex) {
    return ex;
  }
};

export const getDebtWriteOffDocUploadUrls = reqData => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msGetDebtWriteOffDocUploadUrls,
        monoHandler: monoGetDebtWriteOffDocUploadUrls,
        extraData: reqData,
      }
    );

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoGetCreditWriteOffDocUploadURL = async (_, reqData) => {
  try {
    const bulkMutationReqData = (reqData || []).map((item, idx) => ({
      queryKey: `docUpload${idx + 1}`,
      key: 'getCreditWriteOffSupportingDocumentUploadURL',
      query: '{ Url, Key, Filename }',
      variables: [
        {
          file: {
            filename: item.file.name,
            filepath: item.file.path,
            filesize: item.file.size,
            mimetype: item.file.type,
          },
        },
      ],
    }));
    const response = await SkApolloRequest({
      params: bulkMutationReqData,
      type: 'bulkMutation',
    });
    return response;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetCreditWriteOffDocUploadURL',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: [{ message: parseGraphQLError(ex) }],
    };
  }
};

export const getCreditWriteOffDocUploadURL = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetCreditWriteOffSupportingDocumentUploadURL,
      monoHandler: monoGetCreditWriteOffDocUploadURL,
      extraData: reqData,
    }
  );
};

export const monoGetAllProgramBillings = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: LIST_PROGRAM_BILLINGS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllProgramBillings',
        fileName,
      },
      'error'
    );
    throw ex;
  }
};

export const getAllProgramBillings = reqData => async dispatch => {
  dispatch(allProgramBillingLoading());
  try {
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllProgramBillings,
        monoHandler: monoGetAllProgramBillings,
        extraData: reqData,
      }
    );

    if (resp.success) {
      dispatch(allProgramBillingSuccess(resp.data));
    } else {
      dispatch(allProgramBillingError(resp.error));
    }
  } catch (ex) {
    dispatch(allProgramBillingError(ex.message));
  }
};

export const monoFetchAllCreditDebitNotes = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CREDIT_DEBIT_NOTES,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAllCreditDebitNotes',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchAllCreditDebitNotes = reqData => async dispatch => {
  dispatch(creditDebitNoteLoading());
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAllCreditDebitNotes,
      monoHandler: monoFetchAllCreditDebitNotes,
      extraData: reqData,
    }
  );
  if (resp.success) {
    dispatch(creditDebitNoteSuccess(resp.data));
  } else {
    dispatch(creditDebitNoteError(resp.error));
  }
  return resp;
};

export const monoGetRegistrationChildBalanceSheet = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: LIST_REGISTRATION_CHILD_BALANCE_SHEET,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetRegistrationChildBalanceSheet',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getRegistrationChildBalanceSheet = reqData => async dispatch => {
  dispatch(allRegChildBalanceLoading());
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetRegistrationChildBalanceSheet,
      monoHandler: monoGetRegistrationChildBalanceSheet,
      extraData: reqData,
    }
  );
  if (resp.success) {
    dispatch(allRegChildBalanceSuccess(resp.data));
  } else {
    dispatch(allRegChildBalanceError(resp.error));
  }
  return resp;
};

export const getRegistrationChildTotalAdvancePaymentAmount =
  reqData => async dispatch => {
    dispatch(allRegTotalAdvancePaymentAmountLoading());
    try {
      const data = await SkApolloRequest({
        params: {
          query: LIST_REGISTRATION_TOTAL_ADVANCE_PAYMENTS,
          variables: reqData,
        },
        type: 'query',
      });
      if (data.success) {
        dispatch(allRegTotalAdvancePaymentAmountSuccess(data.data));
      } else {
        dispatch(allRegTotalAdvancePaymentAmountError(data.error));
      }
      return data;
    } catch (ex) {
      dispatch(allRegTotalAdvancePaymentAmountError(ex.ex.message));
    }
  };

export const monoGetRegistrationRefundChildBalance = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_REG_CHILD_REFUNDS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetRegistrationRefundChildBalance',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getRegistrationRefundChildBalance = reqData => async dispatch => {
  dispatch(allRegChildRefundsLoading());
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetRegistrationRefundChildBalance,
      monoHandler: monoGetRegistrationRefundChildBalance,
      extraData: reqData,
    }
  );
  if (resp.success) {
    dispatch(allRegChildRefundsSuccess(resp.data));
  } else {
    dispatch(allRegChildRefundsError(resp.error));
  }
  return resp;
};

export const monoTransferChildBalance = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: TRANSFER_CHILD_BALANCE,
        variables: { dto: reqData },
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoTransferChildBalance',
        fileName,
      },
      'error'
    );
    return { success: false, error: parseGraphQLError(ex) };
  }
};

export const transferChildBalance = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msTransferChildBalance,
      monoHandler: monoTransferChildBalance,
      extraData: reqData,
    }
  );
};

export const monoTransferRegistrationChildBalance = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: TRANSFER_REG_CHILD_BALANCE,
        variables: { dto: reqData },
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoTransferRegistrationChildBalance',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const transferRegistrationChildBalance = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msTransferRegistrationChildBalance,
      monoHandler: monoTransferRegistrationChildBalance,
      extraData: reqData,
    }
  );
};

export const monoUpdateRefundStatus = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: UPDATE_REFUND_STATUS,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoUpdateRefundStatus',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const updateRefundStatus = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUpdateRefundStatus,
      monoHandler: monoUpdateRefundStatus,
      extraData: reqData,
    }
  );
};

export const monoAdjustInvoiceAmountByInvoiceItemsPreview = async (
  dispatch,
  reqData
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: ADJUST_INVOICE_AMOUNT_ITEMS_PREVIEW,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const adjustInvoiceAmountByInvoiceItemsPreview =
  reqData => async dispatch => {
    try {
      dispatch(allAdjustInvoiceAmountLoading());
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msAdjustInvoiceAmountByInvoiceItemsPreview,
          monoHandler: monoAdjustInvoiceAmountByInvoiceItemsPreview,
          extraData: reqData,
        }
      );
      if (data.success) {
        dispatch(allAdjustInvoiceAmountSuccess(data.data));
      } else {
        dispatch(allAdjustInvoiceAmountError(data.error));
      }
      return data;
    } catch (ex) {
      dispatch(allAdjustInvoiceAmountError(ex.message));
      return ex;
    }
  };

export const monoAdjustInvoiceAmountByInvoiceItems = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: ADJUST_INVOICE_AMOUNT_ITEMS,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const adjustInvoiceAmountByInvoiceItems = reqData => async dispatch => {
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msAdjustInvoiceAmountByInvoiceItems,
      monoHandler: monoAdjustInvoiceAmountByInvoiceItems,
      extraData: reqData,
    }
  );
  return data;
};

export const monoSkipGiroForRegistration = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: SKIP_GIRO_REG,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSkipGiroForRegistration',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const skipGiroForRegistration = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSkipGiroForRegistration,
      monoHandler: monoSkipGiroForRegistration,
      extraData: reqData,
    }
  );
};

export const monoSkipRegistrationPaymentStep = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: SKIP_PAYMENT_REG,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSkipRegistrationPaymentStep',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const skipRegistrationPaymentStep = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSkipRegistrationPaymentStep,
      monoHandler: monoSkipRegistrationPaymentStep,
      extraData: reqData,
    }
  );
};

export const monoSkipEcdaRegistrationPaymentStep = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: SKIP_ECDA_PAYMENT_REG,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSkipEcdaRegistrationPaymentStep',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const skipEcdaRegistrationPaymentStep = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSkipEcdaRegistrationPaymentStep,
      monoHandler: monoSkipEcdaRegistrationPaymentStep,
      extraData: reqData,
    }
  );
};

export const monoCancelAdvancePaymentReceipt = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: CANCEL_ADVANCE_PAYMENT_RECEIPT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCancelAdvancePaymentReceipt',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const cancelAdvancePaymentReceipt = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelAdvancePaymentReceipt,
      monoHandler: monoCancelAdvancePaymentReceipt,
      extraData: reqData,
    }
  );
};

export const monoWriteOffCreditBalance = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: WRITE_OFF_CREDIT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoWriteOffCreditBalance',
        fileName,
      },
      'error'
    );
    return parseGraphQLError(ex);
  }
};

export const writeOffCreditBalance = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msWriteOffCreditBalance,
    monoHandler: monoWriteOffCreditBalance,
    extraData: reqData,
  });

export const monoUpdateChildTradeDebtNotificationConfig = async (
  _,
  reqData
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UPDATE_CHILD_TRADE_DEBT_NOTIFY,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const updateChildTradeDebtNotificationConfig = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msUpdateChildTradeDebtNotificationConfig,
    monoHandler: monoUpdateChildTradeDebtNotificationConfig,
    extraData: reqData,
  });

export const monoGetTradeDebtNotifications = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: TRADE_DEBT_NOTIFICATIONS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const getTradeDebtNotifications = reqData => async dispatch => {
  dispatch(tradeDebtNotificationsLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetTradeDebtNotifications,
        monoHandler: monoGetTradeDebtNotifications,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatch(tradeDebtNotificationsSuccess(data.data));
    } else {
      dispatch(tradeDebtNotificationsError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(tradeDebtNotificationsError(get(ex, 'message', DEFAULT_ERROR)));
  }
};

export const monoGetHHIHistory = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: HHI_HISTORY,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetHHIHistory',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getHHIHistory = reqData => async dispatch => {
  dispatch(hhiHistoryLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetHHIHistory,
        monoHandler: monoGetHHIHistory,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatch(hhiHistorySuccess(data.data));
    } else {
      dispatch(hhiHistoryError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(hhiHistoryError(get(ex, 'message', DEFAULT_ERROR)));
  }
};

const monoMarkChildToGenerateGiroRefund = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: MARK_CHECKED_REFUND,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const markChildToGenerateGiroRefund = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msMarkChildToGenerateGiroRefund,
      monoHandler: monoMarkChildToGenerateGiroRefund,
      extraData: reqData,
    }
  );
};

const monoUnmarkChildToGenerateGiroRefund = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UNMARK_CHECKED_REFUND,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const unmarkChildToGenerateGiroRefund = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUnmarkChildToGenerateGiroRefund,
      monoHandler: monoUnmarkChildToGenerateGiroRefund,
      extraData: reqData,
    }
  );
};

export const monoGetCurrentChildRefundStatus = async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: CHECKED_REFUND_COUNTS,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const getCurrentChildRefundStatus = () => async dispatch => {
  dispatch(getCurrentChildRefundStatusLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetCurrentChildRefundStatus,
        monoHandler: monoGetCurrentChildRefundStatus,
        extraData: {},
      }
    );
    if (data.success) {
      dispatch(getCurrentChildRefundStatusSuccess(data.data));
    } else {
      dispatch(getCurrentChildRefundStatusError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(
      getCurrentChildRefundStatusError(get(ex, 'message', DEFAULT_ERROR))
    );
  }
};

export const monoCancelExportGiroRefund = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CANCEL_EXPORT_GIRO_REFUND,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCancelExportGiroRefund',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const cancelExportGiroRefund = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelExportGiroRefund,
      monoHandler: monoCancelExportGiroRefund,
      extraData: reqData,
    }
  );
};

export const monoGetAllRefundChildBalance = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CHILD_REFUNDS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllRefundChildBalance',
        fileName,
      },
      'error'
    );
    dispatch(allChildRefundsError(ex?.ex?.message));
    return { error: ex?.ex?.message };
  }
};

export const getAllRefundChildBalance = reqData => async dispatch => {
  dispatch(allChildRefundsLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllRefundChildBalance,
        monoHandler: monoGetAllRefundChildBalance,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatch(allChildRefundsSuccess(data.data));
    } else {
      dispatch(allChildRefundsError(data.error));
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoFetchAdvancePaymentReceiptsForEcdaRegistration = async (
  _,
  reqData
) => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_ADVANCE_PAYMENT_RECEIPTS_FOR_ECDA_REGISTRATION,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAdvancePaymentReceiptsForEcdaRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchAdvancePaymentReceiptsForEcdaRegistration =
  reqData => async dispatch => {
    dispatchAdvancePaymentReceiptsForEcdaRegistration(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchAdvancePaymentReceiptsForEcdaRegistration,
        monoHandler: monoFetchAdvancePaymentReceiptsForEcdaRegistration,
        extraData: reqData,
      }
    );
    if (resp.success) {
      dispatchAdvancePaymentReceiptsForEcdaRegistration(
        dispatch,
        false,
        resp.data
      );
    } else {
      dispatchAdvancePaymentReceiptsForEcdaRegistration(
        dispatch,
        false,
        null,
        resp.error
      );
    }
    return resp;
  };

export const monoGetFinanceDocumentPdfPresignedURL = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: FINANCE_DOC_PDF_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return parseGraphQLError(ex);
  }
};

export const getFinanceDocumentPdfPresignedURL = reqData => async dispatch => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetFinanceDocumentPdfPresignedURL,
        monoHandler: monoGetFinanceDocumentPdfPresignedURL,
        extraData: reqData,
      }
    );
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoGetAllRefundForChild = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CHILD_REFUNDS,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllRefundForChild',
        fileName,
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const getAllRefundForChild = async reqData =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetAllRefundChildBalance,
    monoHandler: monoGetAllRefundForChild,
    extraData: reqData,
  });

export const monoGetAllRefundChildBalanceForECDA = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_CHILD_REFUNDS_FOR_ECDA,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllRefundChildBalanceForECDA',
        fileName,
      },
      'error'
    );
    const errorMessage = ex?.message?.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const getAllRefundChildBalanceForECDA = async reqData =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msGetAllRefundChildBalanceForECDA,
    monoHandler: monoGetAllRefundChildBalanceForECDA,
    extraData: reqData,
  });
